<template>
  <transition name="fade">
    <div class="create-posts">
      <div class="posts-container">
        <div class="close-icon" @click="$emit('close-upload-pop')">
          <Icon type="md-close"></Icon>
        </div>
        <div class="content-container">
          <div class="tabs-container">
            <div
              class="tabs-item"
              :class="[type == 2 ? 'active' : '']"
              @click="onChangeTab(2)"
            >
              上传视频
            </div>
            <div
              class="tabs-item"
              :class="[type == 1 ? 'active' : '']"
              @click="onChangeTab(1)"
            >
              上传图文
            </div>
          </div>

          <Upload
            type="drag"
            :action="upload_url"
            :data="{ dir: 'template' }"
            :multiple="type == 1"
            :before-upload="onBeforeUpload"
            :on-success="
              (response, file, fileList) =>
                handleSuccess(
                  response,
                  file,
                  fileList,
                  type == 1 ? 'img_list' : 'video'
                )
            "
            :show-upload-list="false"
            :format="type == 1 ? format_img : format_video"
            :accept="type == 1 ? accept_img : accept_video"
          >
            <template>
              <div class="upload-container">
                <div class="upload-content">
                  <!-- <Spin fix v-if="uploading">
                    <Icon
                      type="ios-loading"
                      size="40"
                      class="spin-icon-load"
                    ></Icon>
                    <div>上传中</div>
                  </Spin> -->
                  <img
                    src="../assets/images/icon-create-upload.png"
                    alt=""
                    class="up-icon"
                  />
                  <div class="up-text">
                    拖拽{{ type == 2 ? "视频" : "图片" }}到此或点击上传
                  </div>
                  <div class="up-img-tip" v-if="type == 1">
                    (每次最多支持上传18张)
                  </div>
                  <Button class="up-btn"
                    >上传{{ type == 2 ? "视频" : "图片" }}</Button
                  >
                </div>
              </div>
              <video style="display: none" ref="video" muted></video>
              <canvas style="display: none" ref="canvas"></canvas>
            </template>
          </Upload>

          <div class="bottom-container" v-if="type == 2">
            <div class="bottom-items">
              <div class="title-line">视频大小</div>
              <div class="text-line">支持时长60分钟以内</div>
              <div class="text-line">最大20GB的视频文件</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">视频格式</div>
              <div class="text-line">支持常用视频格式</div>
              <div class="text-line">推荐使用MP4、MOV</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">视频分辨率</div>
              <div class="text-line">推荐上传720P(1280*720)及以上视频</div>
              <div class="text-line">超过1080P的视频用网页端上传画质更清晰</div>
            </div>
          </div>
          <div class="bottom-container" v-else>
            <div class="bottom-items">
              <div class="title-line">图片大小</div>
              <div class="text-line">支持上传的图片大小</div>
              <div class="text-line">最大32MB的图片文件</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">图片格式</div>
              <div class="text-line">支持上传的图片格式,推荐使用</div>
              <div class="text-line">PNG、JPG、JPEG、WEBP，不支持GIF、</div>
              <div class="text-line">LIVE及其转化后的图片</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">图片分辨率</div>
              <div class="text-line">不限制宽高比例，推荐上传3:4至2:1之间</div>
              <div class="text-line">分辨率不低于720*960的照片</div>
              <div class="text-line">超过1280P的图片用网页端上传画质更清晰</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { CreatePosts } from "@/api/social";
import videoMixin from "@/mixins/video.js";
import { uploadFileToOSS } from "@/utils/oss";
export default {
  name: "CreatePosts",
  data() {
    return {
      type: 1,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      format_img: ["jpg", "jpeg", "png", "gif",'webp'],
      format_video: ["mp4", "mov"],
      accept_img: ".jpg,.jpeg,.png,.gif,.webp",
      accept_video: ".mp4,.mov",
      image_list: [],
      video_url: "",
      uploading: false,
      uploadQueue:[],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
    };
  },
  mixins: [videoMixin],
  props: {
    incomeType: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    if (this.incomeType) {
      this.type = this.incomeType;
    }
  },
  methods: {
    onChangeTab(type) {
      this.type = type;
    },
    async onPostsCreate() {
      try {
        const { type, image_list, video_url, video_info } = this;
        const { file_size, duration, cover, name } = video_info;
        const param = {};
        param.type = type;
        param.image_list = image_list;
        param.video = video_url;
        param.media_info = { file_size, duration, name };
        param.cover = cover;
        param.status = -1;
        const { data } = await CreatePosts(param);
        console.log("data", data);
        this.$router.push({ name: "Posts", params: { uuid: data.uuid } });
      } catch (e) {
        this.$layer.msg(e.msg);
      } finally {
        this.$emit("close-upload-pop");
      }
    },
    async processAllFiles() {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`开始上传 ${queue.length} 个文件`);

      for (const file of queue) {
        try {
          const url = await uploadFileToOSS(file, "template",true);

          if (this.type === 1) {
            this.image_list.push(url);
            if (this.image_list.length >= 18) {
              this.$layer.msg("最多上传18张图片");
            }
          } else {
            this.video_url = url;
          }
        } catch (err) {
          if(err.code === 'IMAGE_SIZE_LIMIT'){
              this.$layer.msg(`图片【${file.name}】像素超过限制,最大宽度不能超过4096或者总体像素值不能超过9437184`);
              return;
          }
          this.$layer.msg(`上传失败：${file.name}`);
        }
      }

      // 所有文件上传完成后执行一次提交逻辑
      this.onPostsCreate();
    },
    onBeforeUpload(file) {
      console.log("file-before", file);
      this.uploading = true;
      if (this.type == 2) {
        this.video_info.name = file.name;
        this.onVideoExcute(file);
      }
       // 将文件加入队列
       this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
        this.processAllFiles();
      }, this.debounceTime);
      // this.processAllFiles(); 
      // uploadFileToOSS(file, "template")
      //   .then((url) => {
      //     // console.log('url',url);
      //     console.log("type", this.type);
      //     if (this.type === 1) {
      //       console.log("url", url);
      //       this.image_list.push(url);
      //       if (this.image_list.length >= 18) {
      //         this.$layer.msg("最多上传18张图片");
      //         this.uploading = false;
      //         this.onPostsCreate();
      //       } else {
      //         this.uploading = false;
      //         this.onPostsCreate();
      //       }
      //     } else {
      //       this.video_url = url;
      //       this.uploading = false;
      //       this.onPostsCreate();
      //     }
      //   })
      //   .catch((err) => {
      //     this.$layer.msg("上传失败：" + err.message);
      //     this.uploading = false;
      //   });
      return false;
    },
    handleSuccess(response, file, fileList, field) {
      const length = this.image_list.length;
      if (length >= 18) {
        this.$layer.msg("最多上传16张图片");
        return;
      }
      console.log("file", file);
      if (field === "img_list") {
        this.image_list.push(response.data.url);
      } else {
        console.log("video__info", this.video_info);
        this.video_url = response.data.url;
        this.uploading = false;
        //TODO 发起数据提交
        this.onPostsCreate();
      }

      if (fileList.length === this.image_list.length) {
        this.uploading = false;
        //TODO 发起数据提交
        this.onPostsCreate();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.create-posts {
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .posts-container {
    // width:930px;
    // height:650px;
    border-radius: 10px;
    background: white;
    position: relative;
    .close-icon {
      position: absolute;
      top: 20px;
      right: 25px;
      cursor: pointer;
    }
    .content-container {
      padding: 40px 30px;
      .tabs-container {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 25px;
        .tabs-item {
          font-size: 18px;
          color: #000000;
          padding-bottom: 10px;
          margin-right: 45px;
          cursor: pointer;
          &.active {
            color: #ff5e52;
            border-bottom: 3px solid #ff5e52;
          }
        }
      }
      .upload-container {
        width: 871px;
        height: 421px;
        border: 1px dashed #dbdbdb;
        background: #f7f7f7;
        display: flex;
        justify-content: center;
        .upload-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .up-icon {
            width: 100px;
            height: 65px;
          }
          .up-text {
            font-size: 14px;
            color: #333333;
            margin-top: 30px;
          }
          .up-img-tip {
            font-size: 12px;
            color: #666666;
            margin-bottom: 30px;
          }
          .up-btn {
            background: #fe5866;
            border-radius: 5px;
            color: #ffffff;
          }
        }
      }
      .bottom-container {
        margin-top: 25px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .bottom-items {
          flex: 0 0 33.33%;
          text-align: center;
          &:nth-child(2) {
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
          }
          .title-line {
            font-size: 14px;
            color: #1a1a1a;
            margin-bottom: 10px;
          }
          .text-line {
            font-size: 12px;
            color: #666666;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
